<template>
<div id="app">
  <div class="main_container">
    <div class="main_nav">
      <button @click="nav_push_home()" class="main_text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;You <span>vs</span> Bot</button>
      <button type="button" class="dropdown_btn" name="button" @click="show_nav_menu()"><img src="./assets/arrow.png" width="35" alt=""></button>
    </div>

    <div class="sec_conatainer">
      <div class="row main_row h-100 text-center">
        <div class="col col-2 side_col_1">
        </div>
        <div class="col center_col text-center">
          <transition name="router_view" mode="out-in">
            <keep-alive>
              <router-view />
            </keep-alive>
          </transition>
        </div>
        <div class="col col-2 side_col_3">
        </div>
      </div>
    </div>
    <div class="footer">
      <span></span>
    </div>
  </div>


  <modal name="nav_menu" transition="pop-out" :width="modalWidth" height="auto">
    <div class="box">
      <button type="button" name="button" id="ttt_hit" class="nav_button" :class="active_nav == 'tictactoe' ?'active_nav' : '' " @click="nav_push_1()">
        Tic tac toe
      </button>
      <button type="button" name="button" id="db_hit" class="nav_button" :class="active_nav == 'dotsandboxes' ?'active_nav' : '' " @click="nav_push_2()">
        Dots and boxes
      </button>
      <button type="button" name="button" id="fn_hit" class="nav_button" :class="active_nav == 'findthenumber' ?'active_nav' : '' " @click="nav_push_3()">
        Find the number
      </button>
      <button type="button" name="button" id="tf_hit" class="nav_button" :class="active_nav == 'trueorfalse' ?'active_nav' : '' " @click="nav_push_4()">
        True or false
      </button>
      <div class="modal_footer">
        <button type="button" id="pp_hit" name="button" class="modal_footer_btn" @click="show_pp()">Privacy policy</button>
        <button type="button" id="c_hit" name="button" class="modal_footer_btn" @click="show_c()">Contact</button>
        <div class="c_text">
          <span>© 2019 youvsbot. All rights reserved.</span>
        </div>
      </div>
    </div>
  </modal>

  <modal name="contact" transition="pop-out" :width="modalWidth" height="auto">
    <div class="close_btn_div">
      <button type="button" name="button" class="close_btn" @click="hide_c()">X</button>
    </div>
    <div class="contact_box">
      <span class="check_span">Check</span>
      <input class="check_input" type="text" name="" value="" v-model="check">
      <span>Name</span>
      <input type="text" maxlength="30" name="Name" value="" v-model="name">
      <span>Email</span>
      <input type="text" maxlength="30" name="Email" value="" v-model="email">
      <span>Message</span>
      <textarea name="Message" rows="5" v-model="message" maxlength="500"></textarea>
      <div class="send_btn_div">
        <button type="button" name="button" @click="contact()">Submit</button>
      </div>
      <div class="notification_div">
        <span class="notification success_noti" v-if='this.show_success == "success" '>Received your message.</span>

        <span class="notification error_noti" v-if='this.show_fill == "error" '>Fill all the fields.</span>

        <span class="notification error_noti" v-if='this.show_email == "error" '>Enter a valid email address.</span>
      </div>
    </div>
  </modal>


  <modal name="privacypolicy" transition="pop-out" :width="modalWidth" height="auto" :adaptive="true" :scrollable="true">
    <div class="notes">
      <div class="close_btn_div">
        <button type="button" name="button" class="close_btn" @click="hide_pp()">X</button>
      </div>
      <div class="modal_text_div">
        <h1>Privacy Policy</h1>


        <p>Effective date: September 01, 2019</p>


        <p>youvsbot ("us", "we", or "our") operates the www.youvsbot.com website (the "Service").</p>

        <p>This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.</p>

        <p>We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy
          Policy have the same meanings as in our Terms and Conditions, accessible from www.youvsbot.com</p>


        <h2>Information Collection And Use</h2>

        <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>

        <h3>Types of Data Collected</h3>

        <h4>Personal Data</h4>

        <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:
        </p>

        <ul>
          <li>Cookies and Usage Data</li>
        </ul>

        <h4>Usage Data</h4>

        <p>We may also collect information how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of
          our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>

        <h4>Tracking & Cookies Data</h4>
        <p>We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.</p>
        <p>Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to
          collect and track information and to improve and analyze our Service.</p>
        <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>
        <p>Examples of Cookies we use:</p>
        <ul>
          <li><strong>Session Cookies.</strong> We use Session Cookies to operate our Service.</li>
          <li><strong>Preference Cookies.</strong> We use Preference Cookies to remember your preferences and various settings.</li>
          <li><strong>Security Cookies.</strong> We use Security Cookies for security purposes.</li>
        </ul>

        <h2>Use of Data</h2>

        <p>youvsbot uses the collected data for various purposes:</p>
        <ul>
          <li>To provide and maintain the Service</li>
          <li>To notify you about changes to our Service</li>
          <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
          <li>To provide customer care and support</li>
          <li>To provide analysis or valuable information so that we can improve the Service</li>
          <li>To monitor the usage of the Service</li>
          <li>To detect, prevent and address technical issues</li>
        </ul>

        <h2>Transfer Of Data</h2>
        <p>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from
          your jurisdiction.</p>
        <p>If you are located outside India and choose to provide information to us, please note that we transfer the data, including Personal Data, to India and process it there.</p>
        <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p>
        <p>youvsbot will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there
          are adequate controls in place including the security of your data and other personal information.</p>

        <h2>Disclosure Of Data</h2>

        <h3>Legal Requirements</h3>
        <p>youvsbot may disclose your Personal Data in the good faith belief that such action is necessary to:</p>
        <ul>
          <li>To comply with a legal obligation</li>
          <li>To protect and defend the rights or property of youvsbot</li>
          <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
          <li>To protect the personal safety of users of the Service or the public</li>
          <li>To protect against legal liability</li>
        </ul>

        <h2>Security Of Data</h2>
        <p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal
          Data, we cannot guarantee its absolute security.</p>

        <h2>Service Providers</h2>
        <p>We may employ third party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.</p>
        <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>



        <h2>Links To Other Sites</h2>
        <p>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</p>
        <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>


        <h2>Children's Privacy</h2>
        <p>Our Service does not address anyone under the age of 18 ("Children").</p>
        <p>We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware
          that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.</p>


        <h2>Changes To This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
        <p>We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.</p>
        <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>


        <h2>Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us.</p>
      </div>
    </div>
  </modal>
</div>
</template>



<script>
import firebase from 'firebase/app';
import "firebase/database";
const MODAL_WIDTH = 500

export default {
  name: 'app',
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      active_nav: '',
      check: '',
      name: '',
      email: '',
      message: '',
      show_fill: '',
      show_email: '',
      show_success: ''
    };
  },
  created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ?
      MODAL_WIDTH / 2 :
      MODAL_WIDTH
  },
  methods: {
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    contact() {
      if (this.check != '') {
        this.show_success = 'success';
        setTimeout(function() {
          this.hide_c();
          this.show_success = '';
          this.show_fill = '';
          this.show_email = '';
        }.bind(this), 2000);
      } else {
        if (this.name == '' || this.email == '' || this.message == '') {
          this.show_fill = 'error';
          this.show_success = '';
          this.show_email = '';
        } else if (this.name != '' && this.email != '' && this.message != '' && this.validEmail(this.email) == false) {
          this.show_email = 'error';
          this.show_success = '';
          this.show_fill = '';
        } else if (this.name != '' && this.email != '' && this.message != '' && this.validEmail(this.email) == true) {


          var config = {
            apiKey: "AIzaSyBaXmqCQ1K4x6aChyGiHvdY-nlYvlLzY44",
            authDomain: "youvsbot-1cb17.firebaseapp.com",
            databaseURL: "https://youvsbot-1cb17.firebaseio.com",
            projectId: "youvsbot-1cb17",
            storageBucket: "youvsbot-1cb17.appspot.com",
            messagingSenderId: "486487357378"
          };
          firebase.initializeApp(config);

          var messagesRef = firebase.database().ref('Contact');

          var newMessageRef = messagesRef.push();
          newMessageRef.set({
            name: this.name,
            email: this.email,
            message: this.message
          });

          this.show_success = 'success';
          this.show_fill = '';
          this.show_email = '';
          setTimeout(function() {
            this.hide_c();
            this.show_success = '';
            this.show_fill = '';
            this.show_email = '';
            this.name = '';
            this.email = '';
            this.message = '';
          }.bind(this), 2000);
        }
      }
    },
    show_nav_menu() {
      this.$modal.show('nav_menu');
    },
    hide_nav_menu() {
      this.$modal.hide('nav_menu');
    },
    show_pp() {
      this.hide_nav_menu();
      this.$modal.show('privacypolicy');
    },
    hide_pp() {
      this.$modal.hide('privacypolicy');
    },
    show_c() {
      this.hide_nav_menu();
      this.$modal.show('contact');
    },
    hide_c() {
      this.$modal.hide('contact');
    },
    nav_push_home() {
      this.$router.push({
        path: '/'
      })
      this.hide_nav_menu();
      this.active_nav = ''
    },
    nav_push_1() {
      this.$router.push({
        path: '/tictactoe'
      })
      this.hide_nav_menu();
      this.active_nav = 'tictactoe'
    },
    nav_push_2() {
      this.$router.push({
        path: '/dotsandboxes'
      })
      this.hide_nav_menu();
      this.active_nav = 'dotsandboxes'
    },
    nav_push_3() {
      this.$router.push({
        path: '/findthenumber'
      })
      this.hide_nav_menu();
      this.active_nav = 'findthenumber'
    },
    nav_push_4() {
      this.$router.push({
        path: '/trueorfalse'
      })
      this.hide_nav_menu();
      this.active_nav = 'trueorfalse'
    },
  },

  mounted() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  watch: {
    $route(to, from) {
      if (from.path == "/") {
        if (to.name == "Tictactoe") {
          this.active_nav = 'tictactoe'
        } else if (to.name == "Dotsandboxes") {
          this.active_nav = 'dotsandboxes'
        } else if (to.name == "Findthenumber") {
          this.active_nav = 'findthenumbef'
        } else if (to.name == "Trueorfalse") {
          this.active_nav = 'trueorfalse'
        }
      }
    }
  }
}
</script>

<style>

</style>
